const _excluded = ["className", "tabs", "canClickSelectedTab", "selectedTab", "onTabChange"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { useDeprecate } from '@adsk/alloy-react-helpers';
import Tab from './Tab';
import Tabs from './Tabs';
const TabsAdapter = _ref => {
  let {
      className,
      tabs,
      canClickSelectedTab,
      selectedTab,
      onTabChange
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  useDeprecate(true, '@adsk/alloy-react-tabs', 'TabsAdapter', 'Tabs');
  const onChange = tab => {
    const matchingTab = tabs.find(t => t.id === tab);
    if (matchingTab) {
      onTabChange === null || onTabChange === void 0 ? void 0 : onTabChange(matchingTab);
    }
  };
  return /*#__PURE__*/React.createElement(Tabs, _extends({
    className: className,
    active: selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.id,
    onChange: onChange,
    canClickSelectedTab: canClickSelectedTab
  }, props), tabs.map(tab => /*#__PURE__*/React.createElement(Tab, {
    key: tab.id,
    tab: tab.id,
    label: tab.name()
  })));
};
export const tabShape = PropTypes.shape({
  /**
   * A function that returns the name of the tab
   */
  name: PropTypes.func.isRequired,
  /**
   * The id of the tab (used to match with the selectedTabId)
   */
  id: PropTypes.string.isRequired,
  /**
   * Url to open on mouse middle-click / right-click => open in new tab/window
   * If no onClick is passed for this tab, then also the url to open in a new tab on left click
   */
  url: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  /**
   * Optional function to run when the tab is pressed
   */
  onClick: PropTypes.func
});
TabsAdapter.displayName = 'TabsAdapter';
TabsAdapter.propTypes = {
  /**
   * An optional function that will be called whenever a tab is clicked in the tab navigation area
   */
  onTabChange: PropTypes.func,
  /**
   * The list of tabs in the tab navigation area
   */
  tabs: PropTypes.arrayOf(tabShape).isRequired,
  /**
   * Whether selected tabs are clickable or not. Defaults to true
   */
  canClickSelectedTab: PropTypes.bool,
  /**
   * A custom className for the component container
   */
  className: PropTypes.string,
  /**
   * The selected tab object to highlight in the tab navigation area
   */
  selectedTab: tabShape
};
export default TabsAdapter;
//# sourceMappingURL=TabsAdapter.js.map